import { Box, Button, HStack, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import FormButton from "../../../../../components/button";
import AppChart from "../../../../../components/chart";
import Dropdown from "../../../../../components/dropdown";
import FormInput from "../../../../../components/input";
import { chartdata } from "../../../../../utils/data/chartTestData";
import { measurements } from "../../../../../utils/data/dropdowns";
import ChartProp from "../../../../../utils/types/prop.chart";
import { color } from "../../../../../utils/theme";
import AppSkeleton from "../../../../../components/skeleton";

const CreateChart = ({
  onDiscard,
  onSave,
}: {
  onDiscard: () => void;
  onSave: () => void;
}) => {
  const [chartName, setChartName] = useState("");
  const [selectedMeasurment, setSelectedMeasurment] = useState("");
  const [selectedChart, setSelectedChart] = useState("");
  const [generate, setGenerate] = useState(false);
  const [chartTypes] = useState([
    { label: "Bar", value: "bar" },
    { label: "Line", value: "line" },
  ]);
  const [filterdCharts, setFilterdCharts] = useState<ChartProp[]>(chartdata);
  const [charts] = useState<ChartProp[]>(chartdata);
  const [showChart, setShowChart] = useState(false);
  const [save, setSave] = useState(false);
  const [isGenerateLoading, setIsGenerateLoading] = useState(false);
  const [isLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  useEffect(() => {
    setShowChart(false);
    setSelectedChart("");
    setChartName("");
    setSelectedMeasurment("");
    setGenerate(false);
  }, []);
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setSave(false);
    }, 2000);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [save]);

  const SaveChart = () => {
    setSaveLoading(true);
    setTimeout(() => {
      onSave();
      setSaveLoading(false);
    }, 2000);
  };

  const checkGenerate = () => {
    if (chartName !== "" && selectedMeasurment !== "" && selectedChart !== "") {
      setGenerate(true);
      setShowChart(true);
    } else {
      setGenerate(false);
    }
  };

  const generateChart = () => {
    setIsGenerateLoading(true);
    setTimeout(() => {
      setFilterdCharts(charts.filter((chart) => chart.type === selectedChart));
      setShowChart(true);
      setIsGenerateLoading(false);
    }, 2000);
  };

  const handleDropdownChange = (value: any, stateVariable: any) => {
    switch (stateVariable) {
      case "chartName":
        setChartName(value.target.value);
        checkGenerate();
        break;
      case "selectedMeasurment":
        setSelectedMeasurment(value);
        checkGenerate();
        break;
      case "selectedChart":
        setSelectedChart(value);
        checkGenerate();
        break;
    }
  };

  return (
    <>
      <Box
        width={"100%"}
        h={"100%"}
        gap={5}
        display={"flex"}
        alignContent={"center"}
        alignItems={"center"}
        justifyContent={"center"}
        flexDirection={"row"}
      >
        <Box
          width={"40%"}
          flex={"column"}
          gap={2}
          display={"flex"}
          flexDirection={"column"}
        >
          <FormInput
            id="chartName"
            isRequired={true}
            value={chartName}
            name="chartName"
            label="Chart Name"
            type="text"
            onChange={(value) => {
              handleDropdownChange(value, "chartName");
            }}
            margin="40px 0 0 0"
          />
          {generate && chartName === "" && (
            <Text
              style={{
                color: "#E53E3E",
                fontSize: "14px",
                fontWeight: "600",
                marginTop: "10px",
              }}
            >
              Chart Name is required
            </Text>
          )}
          <Dropdown
            style={{ marginTop: "20px" }}
            placeholder=" "
            value={selectedMeasurment}
            onChange={(value) =>
              handleDropdownChange(value, "selectedMeasurment")
            }
            options={measurements}
            label="Measurment"
          />
          {generate && selectedMeasurment === "" && (
            <Text
              style={{
                color: "#E53E3E",
                fontSize: "14px",
                fontWeight: "600",
                marginTop: "10px",
              }}
            >
              Measurment is Required
            </Text>
          )}
          <Dropdown
            style={{ marginTop: "20px" }}
            placeholder=" "
            value={selectedChart}
            onChange={(value) => handleDropdownChange(value, "selectedChart")}
            options={chartTypes}
            label="Chart Type"
          />
          {generate && selectedChart === "" && (
            <Text
              style={{
                color: "#E53E3E",
                fontSize: "14px",
                fontWeight: "600",
                marginTop: "10px",
              }}
            >
              Chart Type is Required
            </Text>
          )}

          <Button
            onClick={() => {
              generateChart();
            }}
            w={"100%"}
            my={5}
            isLoading={isGenerateLoading}
            colorScheme="blue"
            fontWeight={500}
            variant={"outline"}
          >
            Generate
          </Button>
        </Box>
        {showChart && (
          <Box
            width={"60%"}
            height={"100%"}
            bg={color.secondary}
            sx={{ borderLeftWidth: 1 }}
          >
            <Box
              h={"100%"}
              overflow={"auto"}
              className="slideInFromRight"
              px={5}
              py={5}
            >
              <Box>
                <Text fontWeight={"800"} color={color.text} marginBottom={5}>
                  {chartName}
                </Text>
                {isLoading ? (
                  <AppSkeleton height="300px" width="100%" color={"#d9d9d9"} />
                ) : (
                  <Box
                    pl={"auto"}
                    height="350px"
                    width="100%"
                    background={color.secondary}
                    borderWidth={0.5}
                    borderColor={color.primary}
                    borderRadius={10}
                    p={4}
                    flexDirection={"row"}
                    alignContent={"center"}
                    alignItems={"center"}
                  >
                    <AppChart
                      type={filterdCharts[0].type}
                      data={filterdCharts[0].data}
                      options={filterdCharts[0].options}
                    />
                  </Box>
                )}
                <HStack>
                  {" "}
                  <FormButton
                    style={{ marginTop: "20px", width: "100%" }}
                    onClick={onDiscard}
                  >
                    Discard
                  </FormButton>
                  <FormButton
                    style={{
                      marginTop: "20px",
                      width: "100%",
                      color: color.secondary,
                      fontWeight: "500",
                      background: color.primary,
                    }}
                    onClick={() => SaveChart()}
                    isLoading={saveLoading}
                  >
                    Save
                  </FormButton>
                </HStack>
              </Box>
            </Box>
          </Box>
        )}
      </Box>
    </>
  );
};

export default CreateChart;
